import React, { lazy, Suspense } from 'react';

import { Box } from 'components/@ux/box';
import { Spinner } from 'components/@ux/spinner';

const defaultFallback = (
  <Box color="gray" display="flex" alignItems="center" margin="2rem">
    <Spinner size="2rem" marginRight="1rem" width="3px" />
    Loading...
  </Box>
);

export const dynamic = (fn, fallback) => {
  const Component = lazy(fn);

  return (props = {}) => (
    <Suspense fallback={fallback || defaultFallback}>
      <Component {...props} />
    </Suspense>
  );
};
